import PrimaryButton from "../../../Components/Buttons/primary-button";

import { modalVariants } from "../../../Utils/constants";

export default function renderCurrentBalance(modalContext) {
  const { updateModalComponent, setModalVariant, setModalTitle, onModalClose } = modalContext;

  updateModalComponent(() => (
    <>
      <div className="modal-dialog-content">
        <span className="tooltip-label">What is this?</span>
        <span className="tooltip-description">
          Everything in your account, including money that's still processing or on hold.
        </span>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={onModalClose}>Got It</PrimaryButton>
      </div>
    </>
  ));
  setModalVariant(modalVariants.tooltipDialog);
  setModalTitle("Current Balance");
}
